import { PortfolioState, initialPortfolioState } from '../PortfolioState';
import { PortfolioAction, PortfolioActionType } from './actions';
import { Reducer } from 'redux';

export const portfolioStateReducer: Reducer<PortfolioState, PortfolioAction> = (
    state = initialPortfolioState,
    action
) => {
    switch (action.type) {
        case PortfolioActionType.PORTFOLIO_SET_ACTIVE_INPUT: {
            return {
                ...state,
                activeInputType: action.payload!.activeInputType,
                activeInputWidget: action.payload!.activeInputWidget,
            };
        }
        case PortfolioActionType.PORTFOLIO_SET_SELECTION: {
            return {
                ...state,
                selection: action.payload,
            };
        }
    }
    return state;
};
